import { utils } from 'ethers';
import numbro from 'numbro';
import { PaymentCurrency_Enum } from './__generated__/graphql';
import { Erc20DecimalEnum } from './currencyConvert';
import type { BigNumberish } from 'ethers';

export const budgetFormatter = (
  min_budget?: BigNumberish,
  max_budget?: BigNumberish,
  payment_currency?: string
) => {
  const decimal = !payment_currency
    ? 0
    : Erc20DecimalEnum[payment_currency as keyof typeof Erc20DecimalEnum];

  const budgetFormatted: string[] = [];

  if (min_budget !== undefined) {
    let minBudgetFormattedValue;
    if (payment_currency === PaymentCurrency_Enum.Usdc) {
      minBudgetFormattedValue = utils.formatUnits(min_budget, 6);
      budgetFormatted.push(
        humanizeUSDC(utils.parseUnits(minBudgetFormattedValue, 6))
      );
    } else {
      minBudgetFormattedValue = utils.formatUnits(min_budget, decimal);
      budgetFormatted.push(utils.commify(minBudgetFormattedValue));
    }
  }

  if (max_budget !== undefined && min_budget !== max_budget) {
    let maxBudgetFormattedValue;
    if (payment_currency === PaymentCurrency_Enum.Usdc) {
      maxBudgetFormattedValue = utils.formatUnits(max_budget, 6);
      budgetFormatted.push(
        humanizeUSDC(utils.parseUnits(maxBudgetFormattedValue, 6))
      );
    } else {
      maxBudgetFormattedValue = utils.formatUnits(max_budget, decimal);
      budgetFormatted.push(utils.commify(maxBudgetFormattedValue));
    }
  }

  return budgetFormatted.length > 1
    ? `${budgetFormatted[0]} - ${budgetFormatted[1]} ${
        payment_currency && payment_currency !== PaymentCurrency_Enum.Usdc
          ? payment_currency
          : ''
      }`
    : budgetFormatted.length === 1
    ? `${budgetFormatted[0]} ${
        payment_currency && payment_currency !== PaymentCurrency_Enum.Usdc
          ? payment_currency
          : ''
      }`
    : '';
};

export const humanizeUSDC = (value: BigNumberish) => {
  const scaledValue = utils.formatUnits(value.toString(), 6);

  return numbro(scaledValue).format({
    average: true,
    mantissa: 2,
    trimMantissa: true,
    optionalMantissa: true,
    output: 'currency',
    currencySymbol: '$',
  });
};
